<template>
  <SkeletonItem border-radius="6px" color="var(--grey-2-next)" height="44px" width="100%" />

  <SkeletonItem
    v-if="withCheckbox"
    :appearance="SQUARE"
    :size="XS"
    class="ipl-Checkbox"
    color="var(--grey-2-next)"
  />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ImmediateParentLoader'
})
</script>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

const { SQUARE } = SKELETON_APPEARANCES
const { XS } = SKELETON_SIZES

defineProps({
  withCheckbox: {
    type: Boolean
  }
})
</script>

<style lang="scss" scoped>
.ipl-Checkbox {
  margin: 10px auto 0 14px;
}
</style>
